import { FONTS, COLORS } from '../../constants';

// eslint-disable-next-line no-unused-vars
const styles = theme =>
  // take mobile-first approach to do the styling

  // const minSm = theme.breakpoints.up('sm');
  // const minMd = theme.breakpoints.up('md');
  // const minLg = theme.breakpoints.up('lg');
  // const minXl = theme.breakpoints.up('xl');

  ({
    tableWrapper: {
      width: '100%',
      overflowX: 'scroll',
      position: 'relative',
    },
    table: {
      fontFamily: FONTS.PRIMARY,
      width: '100%',
      borderCollapse: 'collapse',
    },
    tableRow: {
      '& $firstCol': {
        padding: '0 0 0 5px',
      },
    },
    headerCell: {
      backgroundColor: COLORS.GREY_DARK,
      fontWeight: 500,
      color: COLORS.WHITE,
      padding: '20px 10px',
      whiteSpace: 'nowrap',
      position: 'sticky',
      top: 0,
      zIndex: 2,
      lineHeight: '24px',
      textAlign: 'center',

      '&$firstCol': {
        zIndex: 3,
      },

      '& > span': {
        display: 'inline-flex',
        alignItem: 'center',
        justifyContent: 'center',
      },
    },
    cell: {
      textAlign: 'center',
      color: COLORS.GREY_DARK,
      whiteSpace: 'nowrap',
      padding: 0,

      '& div': {
        padding: '20px 20px',
        backgroundColor: COLORS.WHITE,
      },
    },
    customCell: {
      '& div': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
    },
    firstCol: {
      position: 'sticky',
      left: 0,
    },
    clickable: {
      cursor: 'pointer',
    },
    sortArrow: {
      opacity: 0,
      transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
      transform: 'rotate(0)',
    },
    sortArrowEnabled: {
      opacity: 1,
    },
    sortArrowDown: {
      transform: 'rotate(180deg)',
    },
    noData: {
      textAlign: 'center',
      padding: '20px 20px',
    },
  });
export default styles;
